export function formatResultDuration(milliseconds) {
  const value = Math.max(0, Math.round(Number(milliseconds) || 0));
  const seconds = Math.floor(value / 1000);
  const clock = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(number => number < 10 ? '0' + number : String(number)).join(':');
  return clock + '.' + ('00' + (value % 1000)).slice(-3);
}

export function serializeResultDuration(milliseconds, date = new Date()) {
  return date.toISOString().slice(0, 10) + ' ' + formatResultDuration(milliseconds);
}



// WEBPACK FOOTER //
// ./src/utils/result-duration.js